import React from "react";
import { FormControl, InputLabel, MenuItem } from "@material-ui/core";
import ClearableSelect from "./ClearableSelect";
import { CodeHolderHandleFinanciallyType, CodeHolderHandleFinanciallyTypes } from "../../model/CodeHolder";

interface IProps {
    value: CodeHolderHandleFinanciallyType;
    label: string;
    clearable: boolean;
    onChange: (newValue: CodeHolderHandleFinanciallyType | null) => void;
}

const CodeHolderHandleFinanciallyPicker = ({ value, label, clearable, onChange }: IProps) => {
    const render = (): JSX.Element => {
        const safeValue = value ?? "";

        return (
            <FormControl fullWidth>
                <InputLabel shrink>{label}</InputLabel>
                <ClearableSelect
                    clearable={clearable}
                    value={safeValue}
                    showMissingSelectedOptions={true}
                    onClear={() => {
                        onChange(null);
                    }}
                    onChange={(evt: any) => {
                        const nextValue = evt.target.value as CodeHolderHandleFinanciallyType;
                        onChange(nextValue);
                    }}
                >
                    {CodeHolderHandleFinanciallyTypes.map((item, idx) => {
                        return (
                            <MenuItem key={idx} value={item} style={{ marginLeft: 18 }}>
                                {item}
                            </MenuItem>
                        );
                    })}
                </ClearableSelect>
            </FormControl>
        );
    };

    return render();
};

export default CodeHolderHandleFinanciallyPicker;
